<script>
    import FrontendLayout from './layouts/FrontendLayout.svelte';
    import FrontendMessages from './components/FrontendMessages.svelte';
    import FrontendLoading from './components/FrontendLoading.svelte';
    import { UserStore } from './stores/UserStore.svelte.js';
    import FrontendLogin from './layouts/FrontendLogin.svelte';
</script>

<div id="FrontendApp">
    {#if UserStore.isLoggedIn}
        <FrontendLayout />
    {:else}
        <FrontendLogin />
    {/if}

    <FrontendLoading />
    <FrontendMessages />
</div>
